/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector2Like } from 'three';

/**
 * Type guard for Vector2Like
 */
export const isVector2Like = (p: any): p is Vector2Like =>
  p?.isVector2 || (typeof p?.x === 'number' && typeof p?.y === 'number');
